module.exports = __webpack_public_path__ + "01_medium_brown.31df52da.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/01_medium_brown.png
// module id = Tmqw
// module chunks = 0